<template>
  <div id="wrapper">
    <Nav :message="message" />
    <Audit />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import Audit from '@/components/profile/Audit.vue'

export default {
  name: 'audit',
  props: ['message'],
  components: {
    Nav,
    Audit
  }
}
</script>